module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_05 (2).ee2c45db.png";